import { useQuery } from "react-query";

import { ApiResult } from "../api/apiResult";
import { CutoffSource, fetchPlayTo3DCutoffSources } from "../api/ipdp";

export const CUTOFF_SOURCES_QUERY_KEY = "fetchPlayTo3DCutoffSources";

///hook to fetch ipdb fields
export default function useCutoffSources(): ApiResult<CutoffSource[]> {
  const { data, isLoading, isError, refetch } = useQuery<CutoffSource[]>(
    CUTOFF_SOURCES_QUERY_KEY,
    fetchPlayTo3DCutoffSources,
    {
      enabled: false
    }
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
